import { render, staticRenderFns } from "./starMgtDelis.vue?vue&type=template&id=19edc008&"
import script from "./starMgtDelis.vue?vue&type=script&lang=js&"
export * from "./starMgtDelis.vue?vue&type=script&lang=js&"
import style0 from "./starMgtDelis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports